var map = {
	"./1.webp": 764,
	"./10.webp": 765,
	"./11.webp": 766,
	"./12.webp": 767,
	"./2.webp": 768,
	"./3.webp": 769,
	"./4.webp": 770,
	"./5.webp": 771,
	"./6.webp": 772,
	"./7.webp": 773,
	"./8.webp": 774,
	"./9.webp": 775,
	"./GG-Icon": 484,
	"./GG-Icon.png": 484,
	"./background": 776,
	"./background.png": 776,
	"./burger_menu": 485,
	"./burger_menu.png": 485,
	"./club.webp": 777,
	"./error-icon": 334,
	"./error-icon.svg": 334,
	"./handicap_calculator.webp": 778,
	"./log_out.webp": 779,
	"./player_profile.webp": 780,
	"./settings.webp": 781,
	"./stats_center.webp": 782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1372;